module.exports = __webpack_public_path__ + "static/media/crown3.5a3f48ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/crown3.png
// module id = 1991
// module chunks = 4